export class ConflictError extends Error {
  constructor(message, latestRecord = null) {
    super(message);
    this.name = "ConflictError";
    this.latestRecord = latestRecord;
  }
}

export class PermissionError extends Error {
  constructor(message) {
    super(message);
    this.name = "PermissionError";
  }
}

export function friendlyError(error, language = "ko") {
  const english = language === "en";
  if (error instanceof ConflictError) {
    return english
      ? "Another user updated this item first. Reload the latest version and try again."
      : "다른 사용자가 이 항목을 먼저 수정했습니다. 최신 데이터를 확인한 후 다시 저장해 주세요.";
  }
  if (error instanceof PermissionError || error?.code === "42501") {
    return english
      ? "You do not have permission for this operation."
      : "이 작업을 수행할 권한이 없습니다.";
  }
  if (!navigator.onLine) {
    return english
      ? "The network is offline. Changes were not saved."
      : "네트워크가 오프라인입니다. 변경사항은 저장되지 않았습니다.";
  }
  return error?.message || (english ? "The operation failed." : "작업을 완료하지 못했습니다.");
}
